import { FC } from 'react'
import HeaderCSS from '../css/Header.module.css';
import ImageButton from './ImageButton';
import GitHubLogo from '../Images/github-logo.png';
import LinkedInLogo from '../Images/linkedin-logo.png';
import InstagramLogo from '../Images/instagram-logo.png';

const GitHubLink = 'https://github.com/jackmpauly';
const LinkedInLink = 'https://www.linkedin.com/in/jackmpauly/';
const InstagramLink = 'https://www.instagram.com/jackmpauly';

const Header: FC = () => {
    return (
        <div className="container mx-auto rounded-xl" style={{background: "rgba(81, 93, 188, 0.7)"}}>
            <div className={HeaderCSS.topBar}>
                <ImageButton link={GitHubLink} path={GitHubLogo} />
                <ImageButton link={LinkedInLink} path={LinkedInLogo} />
                <ImageButton link={InstagramLink} path={InstagramLogo} />
            </div>
            <div className={HeaderCSS.pageTitleText}>
                <a href="/">Jack Pauly</a>
            </div>
            <nav>
                <a href="/about">About</a>
                <a href="/albumsort">Album Sort</a>
                <a href="/spotify">Spotify Sequencer</a>
                <a href="/blog">Blog</a>
            </nav>
        </div>
    )
}

export default Header